import { render, staticRenderFns } from "./VehicleBindingRecord.vue?vue&type=template&id=66bb21a3&scoped=true&"
import script from "./VehicleBindingRecord.vue?vue&type=script&lang=js&"
export * from "./VehicleBindingRecord.vue?vue&type=script&lang=js&"
import style0 from "./VehicleBindingRecord.vue?vue&type=style&index=0&id=66bb21a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb21a3",
  null
  
)

export default component.exports